import { render, staticRenderFns } from "./DevTaskTrend.vue?vue&type=template&id=4fc0d27f&scoped=true"
import script from "./DevTaskTrend.vue?vue&type=script&lang=js"
export * from "./DevTaskTrend.vue?vue&type=script&lang=js"
import style0 from "./DevTaskTrend.vue?vue&type=style&index=0&id=4fc0d27f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc0d27f",
  null
  
)

export default component.exports